import { render, staticRenderFns } from "./LabelTag.vue?vue&type=template&id=47be0d2a"
import script from "./LabelTag.vue?vue&type=script&lang=js"
export * from "./LabelTag.vue?vue&type=script&lang=js"
import style0 from "./LabelTag.vue?vue&type=style&index=0&id=47be0d2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports